import React, { FC, useCallback } from 'react'
import { push } from 'connected-react-router'
import { generatePath, useParams } from 'react-router-dom'

import Step1 from './Step1'
import Step2 from './Step2'
import Step3 from './Step3'
import Step4 from './Step4'

import { useDispatch, useSelector } from '../../store'
import { getMeThunk } from '../../store/auth/thunks'

import './CreateProject.scss'
import { NON_AUTH_ROUTE } from '../App/routes'
import { isFulfilled } from '@reduxjs/toolkit'
import { setUserRoleAction } from '../../store/auth/slice'
import { chooseProjectAction } from '../../store/project/slice'

interface CreateProjectProps { }

interface CreateProjectParams {
  step: string
}

const CreateProject: FC<CreateProjectProps> = (props) => {
  const { inProgress, location } = useSelector((state) => ({
    inProgress: state.agency.inProgress,
    location: state.router.location
  }))
  const dispatch = useDispatch()
  const { step } = useParams<CreateProjectParams>()

  const { project } = (location as any).query

  const goForward = useCallback(
    async (newProjectId?: string) => {
      let nextRoute

      // 4 to connect socials
      if (Number(step) !== 3) {
        nextRoute = generatePath(
          `/create-project/:step${
            newProjectId || project ? `/?project=${project || newProjectId}` : ''
          }`,
          {
            step: Number(step) + 1
          }
        )
      } else {
        const responseGetMe = await dispatch(getMeThunk())
        nextRoute = '/'
      }

      dispatch(push(nextRoute))
    },
    [project, step, dispatch]
  )

  const skipCreation = () => {
    dispatch(push(NON_AUTH_ROUTE.LOGIN))
  }

  const renderCurrentStep = () => {
    const stepProps = {
      goForward,
      skipCreation,
      inProgress,
      project_id: project || null
    }

    switch (Number(step)) {
      case 1:
        return <Step1 {...stepProps} />
      case 2:
        return <Step2 {...stepProps} />
      case 3:
        return <Step3 {...stepProps} />
      case 4:
        return <Step4 {...stepProps} />

      default:
        return null
    }
  }

  return renderCurrentStep()
}

export default CreateProject
